// members.js (em migração do global.js)
// Constantes exclusivas de Membros (Alunos/Clientes)

import { getOptionsFromMap } from './common';

export const MEMBER_SUB_STATUS = {
    NONE: 0,
    PENDING_ASSESSMENT: 1,
    BIOIMPEDANCE: 2,
    PARQ: 3,
    DEBT: 7
};

export const MEMBER_SUB_STATUS_LABELS = {
    [MEMBER_SUB_STATUS.NONE]: 'Nenhum',
    [MEMBER_SUB_STATUS.PENDING_ASSESSMENT]: 'Avaliação Pendente',
    [MEMBER_SUB_STATUS.BIOIMPEDANCE]: 'Bioimpedância Pendente',
    [MEMBER_SUB_STATUS.PARQ]: 'PAR-Q Pendente',
    [MEMBER_SUB_STATUS.DEBT]: 'Inadimplente'
};

export const MEMBER_SUB_STATUS_OPTIONS = getOptionsFromMap(MEMBER_SUB_STATUS, MEMBER_SUB_STATUS_LABELS);

export const MEMBER_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    SUSPENDED: 'suspended',
    LEAD: 'lead'
};

export const MEMBER_STATUS_LABELS = {
    [MEMBER_STATUS.ACTIVE]: 'Ativo',
    [MEMBER_STATUS.INACTIVE]: 'Inativo',
    [MEMBER_STATUS.SUSPENDED]: 'Suspenso',
    [MEMBER_STATUS.LEAD]: 'Lead / Prospect'
};

export const MEMBER_STATUS_OPTIONS = getOptionsFromMap(MEMBER_STATUS, MEMBER_STATUS_LABELS);
